import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "h-96 overflow-auto" }

import { onMounted, toRefs } from "vue";
import { useConfig }         from "../../../config";

// Components
import pdf from "pdfvuer";


export default /*#__PURE__*/_defineComponent({
  props: {
        file: {
            type:     Object,
            required: true
        },
        url:  {
            type:     String,
            required: true
        }
    },
  setup(__props) {

const props = __props



const { file, url } = toRefs( props );
const { config }    = useConfig();

onMounted( async (): void => {
    config.value.src = pdf.createLoadingTask( `${ url.value }/${ file.value.id }` );

    try {
        const pdf             = await config.value.src.promise;
        config.value.numPages = pdf.numPages;
    } catch ( e ) {
        console.log( e );
    }
} );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(config).numPages, (i) => {
      return (_openBlock(), _createBlock(_unref(pdf), {
        key: i,
        src: _unref(config).src,
        page: i
      }, null, 8, ["src", "page"]))
    }), 128))
  ]))
}
}

})